import React from 'react'
import styled from 'styled-components'
import { useStaticQuery, graphql } from 'gatsby'

import DropdownNav from 'src/components/Navbar/DropdownNav'
import { InternalLink } from 'src/components/shared/text'
import { ActionButton } from 'src/components/shared/buttons'
import { media, getScreenType } from 'src/utils/style-helper'

const Container = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-wrap: wrap;
  position: relative;
  ${media.mobile`
    margin: 30px auto 20px auto;
  `}
  ${media.tablet`
    margin: 30px auto 10px auto;
  `}
  ${media.desktop`
    max-width: 1265px;
    margin: 30px auto 0px auto;
  `}
`

const query = graphql`
  query TagsQuery {
    allMarkdownRemark(limit: 1000) {
      group(field: frontmatter___tags) {
        fieldValue
        totalCount
      }
    }
  }
`

const CategoryNav = () => {
  const data = useStaticQuery(query)

  const categories = data.allMarkdownRemark.group.map((category) => {
    const slug = category.fieldValue.toLowerCase().split(' ').join('-')
    return {
      label: category.fieldValue,
      slug: `/categories/${slug}`,
    }
  })

  const pathname = typeof window !== 'undefined' && window.location.pathname
  const isMobile = getScreenType() === 'mobile'

  return (
    <Container>
      {isMobile ? (
        <DropdownNav categories={categories} />
      ) : (
        categories.map((category) => {
          const activePath = pathname === category.slug
          return (
            <InternalLink
              to={activePath ? '/' : category.slug}
              key={category.label}
              name={category.label}
            >
              <ActionButton copy={category.label} navDrawer activePath={activePath} />
            </InternalLink>
          )
        })
      )}
    </Container>
  )
}

export default CategoryNav
